import { enums } from "./enums";

interface CancerWithGroup {
  id: number;
  name: string;
  status?: number;
  group?: string | null;
}

export interface GroupedCancerOption {
  label: string;
  options: { value: string; label: string }[];
}

export const convertCancersToGroupedOptions = (
  cancers: CancerWithGroup[]
): GroupedCancerOption[] => {
  const cancerGroups = enums.cancerGroups;
  const groupMap = new Map<string, { value: string; label: string }[]>();

  cancerGroups.forEach((group) => {
    groupMap.set(group.id, []);
  });

  cancers
    .filter((c) => (c.status === undefined || c.status === 1) && c.id !== 0)
    .forEach((cancer) => {
      const option = {
        value: cancer.id.toString(),
        label: cancer.name,
      };

      if (cancer.group && groupMap.has(cancer.group)) {
        groupMap.get(cancer.group)!.push(option);
      } else {
        groupMap.get("inne")!.push(option);
      }
    });

  const result: GroupedCancerOption[] = [];
  cancerGroups.forEach((group) => {
    const options = groupMap.get(group.id);
    if (options && options.length > 0) {
      result.push({ label: group.name, options });
    }
  });

  return result;
};

export const findInGroupedOptions = (
  groups: GroupedCancerOption[],
  value: string
) => {
  for (const group of groups) {
    const found = group.options.find((o) => o.value === value);
    if (found) return found;
  }
  return undefined;
};
